import { AxiosInstance } from "axios";
import { failure, ok, pending, Result } from "../common/common";
import { makeAutoObservable } from "mobx";

import { Language } from "../i18n/languages";

import { TMessage } from "../i18n/tt";

export type Affiliate = {
  key: string;
  name: string;
  group: AffiliateGroup;
  language: Language;
};

export enum AffiliateGroup {
  styreforeningen = "styreforeningen",
}

export class AffiliateService {
  constructor(private api: AxiosInstance) {}

  getAffiliateById(affiliateId?: string): Promise<Affiliate> | undefined {
    if (affiliateId) {
      return this.api.get(`/affiliate/${affiliateId}`).then((response) => {
        return response.data;
      });
    }
    return undefined;
  }

  getAffiliateByKey(affiliateKey: string): Promise<Affiliate> {
    return this.api.get(`/affiliate-by-key/${affiliateKey}`).then((response) => {
      return response.data;
    });
  }

  addAffiliateToSession(affiliateKey: string): Promise<void> {
    return this.api.put(`/add-affiliate/${affiliateKey}`).then((res) => res.data);
  }
}

export class AffiliateController {
  private affiliateKey: string;
  private affiliateService: AffiliateService;
  affiliateResult: Result<Affiliate, TMessage> | undefined = undefined;
  constructor(affiliateKey: string, affiliateService: AffiliateService) {
    this.affiliateKey = affiliateKey;
    this.affiliateService = affiliateService;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  *fetchAffiliate() {
    this.affiliateResult = pending();
    try {
      const result: Affiliate = yield this.affiliateService.getAffiliateByKey(this.affiliateKey);
      this.affiliateResult = ok(result);
      this.addAffiliateToSession(this.affiliateKey);
    } catch (error) {
      this.affiliateResult = failure({ key: "affiliate.get.error" });
    }
  }

  addAffiliateToSession(affiliateKey: string) {
    this.affiliateService.addAffiliateToSession(affiliateKey);
  }
}
